import { render, staticRenderFns } from "./merchant-application.vue?vue&type=template&id=a8830daa&scoped=true&lang=pug"
import script from "./merchant-application.vue?vue&type=script&lang=js"
export * from "./merchant-application.vue?vue&type=script&lang=js"
import style0 from "./merchant-application.vue?vue&type=style&index=0&id=a8830daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8830daa",
  null
  
)

export default component.exports